import { deleteJson, getJson, patchJson, postJson } from "./apiClient";

export const brandProfileService = {
  listAll,
  updateByHash,
  create,
  remove,
  bulkUpsert,
  /** POST scrape + LLM preview for a domain; does not persist. */
  prefillFromWebsite,
};

function listAll() {
  return getJson("/api/v1/brand-profile/");
}

function updateByHash(hash, payload) {
  return patchJson(`/api/v1/brand-profile/${hash}/`, payload);
}

function create(payload) {
  return postJson("/api/v1/brand-profile/", payload);
}

function remove(hash) {
  return deleteJson(`/api/v1/brand-profile/${hash}/`);
}

function bulkUpsert({ brands }) {
  return postJson("/api/v1/brand-profile/bulk-edit/", { brands });
}

function prefillFromWebsite(websiteUrl) {
  return postJson("/api/v1/brand-profile/from-website/", { website_url: websiteUrl });
}
